module.exports = __webpack_public_path__ + "static/img/07.403f45cd.webp";